
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 4H5.75A1.752 1.752 0 0 0 4 5.75v20.5A1.752 1.752 0 0 0 5.75 28h20.5A1.752 1.752 0 0 0 28 26.25V5.75A1.752 1.752 0 0 0 26.25 4Zm.25 22.25a.25.25 0 0 1-.25.25H5.75a.25.25 0 0 1-.25-.25V5.75a.25.25 0 0 1 .25-.25h20.5a.25.25 0 0 1 .25.25v20.5ZM16 8.5a7.5 7.5 0 1 0 7.5 7.5A7.508 7.508 0 0 0 16 8.5ZM16 22a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm-2-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3.707 3.707A1 1 0 0 1 15 19v-1h2v1a1 1 0 0 1-1.707.707Z"}})])
          )
        }
      }
    